module.exports = "/_next/static/images/333b7bf803a745bd5603071dbbf35217-celebration.svg.webp";